import { TranslationInfo } from "@shared/types/translation-info";

// eslint-disable-next-line @tseslint/typedef
export const STATUS_TYPES = {
  neutral: "neutral",
  success: "success",
  error: "error",
  info: "info"
} as const;
export type StatusType = typeof STATUS_TYPES[keyof typeof STATUS_TYPES];
export interface Status {
  translationInfoDisplayName?: TranslationInfo | undefined;
  displayName?: string | undefined;
  statusType: StatusType;
}

function isStatusType (value: unknown): value is StatusType {
  if (value === null || value === undefined || typeof value !== "string") return false;

  const statusTypeKeys: string[] = Object.values(STATUS_TYPES);

  return statusTypeKeys.includes(value);
}

export function isStatus (value: unknown): value is Status {
  if (value === null || value === undefined || typeof value !== "object") return false;

  return "statusType" in value && isStatusType(value.statusType);
}
